<template>
  <div class="post-login-page -mb-14" dir="rtl">
    <!-- Create Password Modal -->
    <div
      v-if="dialog_create_password"
      class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4"
      @click.self="dialog_create_password = false"
    >
      <div class="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        <div class="bg-gradient-to-r from-brand to-blue-600 px-6 py-4 text-white">
          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-3 w-full">
              <img src="../../../public/img/logo.webp" class="w-10 h-10 rounded-lg flex-shrink-0 object-contain bg-white bg-opacity-10" alt="">
              <h2 class="text-lg font-bold truncate">{{ $t('addPassword') }}</h2>
            </div>
            <button
              type="button"
              class="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0"
              @click="dialog_create_password = false"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div class="px-6 py-5 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('select') }}</label>
            <select v-model="create_party" class="modal-field-select">
              <option :value="0" disabled>{{ $t('select') }}</option>
              <option v-for="opt in items" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('password') }}</label>
            <input
              v-model="create_pass"
              type="password"
              :placeholder="$t('password')"
              class="modal-field-input"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('rePassword') }}</label>
            <input
              v-model="create_repass"
              type="password"
              :placeholder="$t('rePassword')"
              class="modal-field-input"
            />
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-xl transition-colors"
            @click="dialog_create_password = false"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-brand to-blue-600 hover:from-brand-dark hover:to-blue-700 text-white font-bold rounded-xl transition-all"
            @click="party_create_password"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Forgot Password Modal -->
    <div
      v-if="dialog_forgot_password"
      class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4"
      @click.self="dialog_forgot_password = false"
    >
      <div class="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        <div class="bg-gradient-to-r from-brand to-blue-600 px-6 py-4 text-white">
          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-3 w-full">
              <img src="../../../public/img/logo.webp" class="w-10 h-10 rounded-lg flex-shrink-0 object-contain bg-white bg-opacity-10" alt="">
              <h2 class="text-lg font-bold truncate">{{ $t('forgotPassword') }}</h2>
            </div>
            <button
              type="button"
              class="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0"
              @click="dialog_forgot_password = false"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div class="px-6 py-5 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('select') }}</label>
            <select v-model="forgot_party" class="modal-field-select">
              <option :value="0" disabled>{{ $t('select') }}</option>
              <option v-for="opt in items" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
          </div>
          <p class="text-sm text-gray-500 leading-relaxed">
            پس از تایید، رمز عبور جدید برای شعبه انتخاب‌شده ارسال می‌شود.
          </p>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-xl transition-colors"
            @click="dialog_forgot_password = false"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="flex-1 px-6 py-3 bg-gradient-to-r from-brand to-blue-600 hover:from-brand-dark hover:to-blue-700 text-white font-bold rounded-xl transition-all"
            @click="party_forgot_password()"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>
    
    <div class="post-login-layout">
      <div class="form-panel">
        <div class="login-card-outer">
          <div class="logo-wrap">
            <img src="../../../public/img/logo.webp" class="logo" alt="ZoodKomak" />
          </div>

          <div class="form-grid">
            <div class="choose-select">
              <label class="sr-only">{{ $t('select') }}</label>
              <select v-model="selected_party" class="plain-select input-modern" @keydown.enter="party_login">
                <option v-for="opt in items" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            
            <div class="relative">
              <input :placeholder="$t('password')" type="password" v-model="party_password" class="plain-input input-modern" @keydown.enter="party_login" />
            </div>
            
            <div class="relative">
              <input :placeholder="$t('internalPhone')" class="plain-input input-modern text-right" type="tel" inputmode="numeric" pattern="[0-9]*" :maxlength="4" @keydown.enter="party_login" />
            </div>
          </div>
          
          <div class="actions">
            <button class="btn primary" v-on:click="party_login()">{{ $t('loginPost') }}</button>
          </div>
          
          <div class="password-links flex gap-6 ">
            <a href="#" class="password-link" v-on:click.prevent="dialog_create_password = true">{{ $t('createPassword') }}</a>
            <a href="#" class="password-link" v-on:click.prevent="dialog_forgot_password = true">{{ $t('forgotPassword') }}</a>
          </div>
          
          <div class="logout-section">
            <button class="btn logout-btn" @click="logout()">
              <svg class="logout-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              خروج از حساب
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import {bus} from "../../main";

  export default {
    data() {
      return {
        create_pass: '',
        create_repass: '',
        create_party:0,
        forgot_party:0,
        errors: [],
        mobile: '',
        fullName: '',
        dialog_create_password: false,
        dialog_forgot_password: false,
        items: [],
        valid: true,
        selected_party: 0,
        party_password: '',

      }
    }, mounted() {
      this.get_posts();
    },
    methods: {

      get_posts() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserParties', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.parties.forEach(function (number) {
                console.log(number.PartyName);
                var obj = {label: number.PartyName, value: number.Id}
                self.items.push(obj);
              });
              if(self.items.length>1){
                self.selected_party = self.items[1].value

              }
              // response.data.parties.forEach(function(item) {
              //   console.log("sdsd"+item)
              //
              // });


            }
          }).catch(e => {
          this.errors.push(e);

        })

      },
      saveImageUrlFromToken() {
        const send_data = {
          MobileNo: String(localStorage.getItem('phone') || '').replace('+98', ''),
          Pass: localStorage.getItem('password'),
        }
        return this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, { show_pros: false })
          .then(response => {
            if (response.data && response.data.ImageUrl) {
              localStorage.setItem('ImageUrl', response.data.ImageUrl)
            }
            if (response.data && response.data.UserId) {
              localStorage.setItem('userId2', response.data.UserId)
            }
          })
          .catch(() => {})
      },
      party_login() {
        if (this.mobile == "") {
          this.errors.push(this.$t('insertMobileNo'))
        }
        if (this.fullName == "") {
          this.errors.push(this.$t('insertFullName'))
        }
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
          "pass": self.persian_to_english(self.party_password),
          "PartyId": self.selected_party,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/LoginByPartyId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              localStorage.setItem("party_id", response.data.partyId);
              localStorage.setItem("branch_name", response.data.BranchName);
              localStorage.setItem("branch_id", response.data.BranchId);
              self.saveImageUrlFromToken().finally(() => {
                self.$router.push({path: "/home-tab", params: {}});
              })

            }else{
              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e);

        })

      },
      party_forgot_password() {
        if (this.forgot_party == 0) {
          return
        }
        this.dialog_forgot_password = false;
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
          "pass": self.persian_to_english(self.party_password),
          "PartyId": self.forgot_party,
        };

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ForgotPartyPassword', send_data, {})
          .then(response => {
            const isSuccess = response.data.error == 0
            bus.$emit('show_toast', [2000, response.data.msg, isSuccess ? 'success' : ''])

          }).catch(e => {
          this.errors.push(e);

        })

      },
      party_create_password() {
        if (this.mobile == "") {
          this.errors.push(this.$t('insertMobileNo'))
        }
        if (this.fullName == "") {
          this.errors.push(this.$t('insertFullName'))
        }
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
          "RepeatPass": self.create_pass,
          "NewPass": self.create_repass,
          "PartyId": self.create_party,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/CreatePartyPassword', send_data, {})
          .then(response => {
            const isSuccess = response.data.error == 0
            bus.$emit('show_toast', [2000, response.data.msg, isSuccess ? 'success' : ''])
            self.dialog_create_password = false
          }).catch(e => {
          this.errors.push(e);

        })

      },
      
      logout() {
        // پاک کردن localStorage
        localStorage.clear()
        
        // پاک کردن sessionStorage
        sessionStorage.clear()
        
        // پاک کردن تمام کوکی‌ها
        document.cookie.split(";").forEach(function(c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/")
        })
        
        // پاک کردن کش مرورگر (Service Worker)
        if ('caches' in window) {
          caches.keys().then(function(names) {
            for (let name of names) {
              caches.delete(name)
            }
          })
        }
        
        // لغو ثبت Service Worker
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
        }
        
        this.$router.push({ name: 'login', params: {} })
      },

    }
  }
</script>
<style scoped>
  /* Modal form fields */
  .modal-field-input,
  .modal-field-select {
    width: 100%;
    min-height: 48px;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 15px;
    color: #111827;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .modal-field-input:focus,
  .modal-field-select:focus {
    border-color: #1c39bb;
    box-shadow: 0 0 0 3px rgba(28, 57, 187, 0.15);
  }

  .modal-field-select {
    cursor: pointer;
    appearance: auto;
  }

  .post-login-page {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
    overflow: hidden;
    position: relative;
  }

  .post-login-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(28, 57, 187, 0.9) 0%, rgba(37, 99, 235, 0.9) 100%);
    backdrop-filter: blur(10px);
    pointer-events: none; /* do not block clicks on menus */
    z-index: 0;
  }
  
  .post-login-layout {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    position: relative;
    z-index: 1;
  }

  /* Form Panel */
  .form-panel {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    position: relative;
  }

  /* Card */
  .login-card-outer {
    position: relative;
    width: 100%;
    max-width: 460px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    padding: 32px 24px 36px 24px;
    box-shadow: 
      0 20px 40px rgba(0, 0, 0, 0.1),
      0 8px 16px rgba(0, 0, 0, 0.05),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transform: translateY(0);
    transition: all 0.3s ease;
  }
  
  
  .logo-wrap { 
    display: grid; 
    place-items: center; 
    margin-bottom: 40px;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
  }
  
  .logo { 
    max-width: 90px; 
    height: auto;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    border-radius: 10px;
  }
  
  .form-grid > * + * { margin-top: 16px; }
  .form-grid > * {
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
  }
  .form-grid > *:nth-child(1) { animation-delay: 0.1s; }
  .form-grid > *:nth-child(2) { animation-delay: 0.2s; }
  .form-grid > *:nth-child(3) { animation-delay: 0.3s; }
  
  .actions { 
    margin-top: 24px;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards 0.4s;
  }

  /* Native inputs: ensure white background for password/internal fields */
  .plain-input {
    width: 100%;
    min-height: 56px;
    background: #ffffff;
    border: 2px solid rgba(226, 232, 240, 0.9);
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 15px;
    color: #111827;
    outline: none;
    transition: all 0.2s ease;
  }

  .plain-input:focus {
    border-color: #1c39bb;
    box-shadow: 0 0 0 4px rgba(28, 57, 187, 0.12), 0 4px 12px rgba(28, 57, 187, 0.18);
    background: #ffffff;
  }

  .plain-select {
    width: 100%;
    min-height: 56px;
    background: #ffffff;
    border: 2px solid rgba(226, 232, 240, 0.9);
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 15px;
    color: #111827;
    outline: none;
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .plain-select:focus {
    border-color: #1c39bb;
    box-shadow: 0 0 0 4px rgba(28, 57, 187, 0.12), 0 4px 12px rgba(28, 57, 187, 0.18);
  }

  .btn {
    width: 100%;
    height: 56px;
    border: 0;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  
  .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  
  .btn:hover::before {
    left: 100%;
  }
  
  .btn:disabled { 
    opacity: 0.6; 
    cursor: not-allowed;
    transform: none;
  }
  
  .btn:not(:disabled):hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(28, 57, 187, 0.4);
  }
  
  .primary { 
    color: #ffffff; 
    background: linear-gradient(135deg, #1c39bb 0%, #2563eb 100%);
    box-shadow: 0 4px 15px rgba(28, 57, 187, 0.3);
  }

  .password-links {
    margin-top: 16px;
    text-align: center;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards 0.5s;
  }

  .password-link {
    display: block;
    color: #1c39bb;
    text-decoration: none;
    font-size: 14px;
    margin-bottom: 8px;
    padding: 4px 0;
    transition: all 0.3s ease;
    position: relative;
  }

  .password-link:hover {
    color: #2563eb;
    text-decoration: underline;
  }

  .password-link:last-child {
    margin-bottom: 0;
  }

  /* Logout Section */
  .logout-section {
    margin-top: 20px;
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards 0.6s;
  }

  .logout-btn {
    background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .logout-btn:not(:disabled):hover {
    box-shadow: 0 8px 25px rgba(220, 38, 38, 0.4);
  }

  .logout-icon {
    flex-shrink: 0;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }
</style>
<style>
/* Limit blue background to this page container only */
.post-login-page { 
   min-height: 100vh; 
   width: 100%; 
   overflow: hidden; 
 }
</style>